import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Flex } from '@components/grid';

import { Icon } from '@components/icons';

const FloatingActionButton = styled(Flex)`
  display: flex;
  width: 36px;
  height: 36px;
  background-color: ${({ dark }) => (dark ? 'black' : 'white')};
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  z-index: 2;

  &:hover {
    background-color: ${({ dark }) => (dark ? 'rgba(0, 0, 0, 0.8)' : 'rgba(255, 255, 255, 0.8)')};
  }
`;

const ModalHeaderButton = ({ onClick, icon, align, ariaLabel, dark, ...props }) => {
  return (
    <FloatingActionButton as="button" align={align} dark={dark} onClick={onClick} aria-label={ariaLabel} {...props}>
      <Icon name={icon} height="20px" width="20px" fill={dark ? 'white' : 'black'} />
    </FloatingActionButton>
  );
};

ModalHeaderButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.string,
  align: PropTypes.oneOf(['left', 'right']),
  ariaLabel: PropTypes.string,
  dark: PropTypes.bool,
};

ModalHeaderButton.defaultProps = {
  ariaLabel: 'Close',
  icon: 'cross',
  align: 'right',
  dark: false,
};

export { ModalHeaderButton };
